import type { ReactNode } from 'react';
import marchio from '../immagini/la-regina-san-marzano.webp';

/**
 * La cornice delle schermate che si vedono prima di entrare: accesso,
 * password dimenticata, ripristino e scelta dell'azienda.
 *
 * Da una parte il modulo, dall'altra una foto — i San Marzano in mano, sulla
 * pianta. È una foto di La Regina, dal loro sito (laregina.com), a 1920×1280:
 * quella che il v2 faceva scorrere dietro l'accesso era la stessa scena ma a
 * 1600×1080 e già sgranata, e sugli schermi ad alta densità si vedeva. Sul
 * telefono la foto non c'è, e non si scarica nemmeno: sta nel foglio di stile
 * solo per gli schermi larghi, e in banchina la rete serve per altro.
 *
 * Il logo è quello di La Regina di San Marzano anche per chi lavora sulla
 * Inc: qui l'azienda non la si conosce ancora, si sceglie dopo.
 */

/** Il motto del marchio, come sta sul logo: non si traduce. */
const MOTTO = 'Qualità Romano dal 1983';

export function CorniceIngresso({ children }: { children: ReactNode }) {
  return (
    <div className="ingresso">
      <main className="ingresso-lato">
        <div className="ingresso-corpo">
          <img
            className="ingresso-logo"
            src={marchio}
            alt="La Regina di San Marzano"
            width={640}
            height={317}
          />
          {children}
        </div>
        <p className="ingresso-piede">
          <span>La Regina</span> · <span>CRM 3.0</span>
        </p>
      </main>
      <div className="ingresso-foto" aria-hidden="true">
        <p className="ingresso-motto">{MOTTO}</p>
      </div>
    </div>
  );
}
